import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const MenuPage = lazy(() => import("./MenuPage"));

const MenuPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <MenuPage />
    </Suspense>
  );
};

export default MenuPageLazy;
